<div class="tech-support-history-card">
    <div>
        <ul *ngIf="caseDetails && caseDetails.length > 0; else emptyState">
            <li *ngFor="let case of (caseDetails.length > 2 ? caseDetails?.slice(0, 2) : caseDetails);">
                {{case.CreatedDate | date: 'MM/dd/yyyy'}} at {{case.CreatedDate | date: 'h:mm a': undefined : 'en-US' }}
                {{ case.Origin?.toLowerCase() === 'phone' ? 'via' : 'in' }} {{case.Origin}}.
            </li>
        </ul>
        <ng-template #emptyState>
            <div class="empty-state"><adp-label labelKey="Account_TechSupport_History_Empty"></adp-label></div>
        </ng-template>
    </div>
</div>